module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "find-job section login_wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loginUser),
      expression: "!loginUser"
    }],
    attrs: {
      "aria-label": "breadcrumb"
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginUser),
      expression: "loginUser"
    }],
    staticClass: "col-md-12 row",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "card4"
  }, [_c('div', {
    staticClass: "container-card"
  }, [_c('h5', {
    staticStyle: {
      "margin-bottom": "10px",
      "color": "mediumseagreen"
    }
  }, [_vm._v("PLAN ACTUAL : "), _c('span', [_vm._v(_vm._s(_vm.tipoPlan.toUpperCase()))]), _vm._v("."), _c('span', {
    staticStyle: {
      "color": "#004085",
      "font-weight": "500"
    }
  }, [_vm._v(" Disponible " + _vm._s(_vm.publicacionesPlan) + " publicaciones de trabajo. Última actualización " + _vm._s(_vm.UltimaFechaRenovacion) + " ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm  col-md-3",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modalPlanes"
    },
    on: {
      "click": function($event) {
        _vm.planes()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ver planes disponibles")])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loginUser),
      expression: "!loginUser"
    }],
    staticClass: "col-md-3 row"
  }, [_c('div', {
    staticClass: "card-flat"
  }, [_c('div', {
    staticClass: "container-card"
  }, [_c('div', {
    staticClass: "login-inner-form"
  }, [_c('div', {
    staticClass: "details"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "200px"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TxtEmailIngresoEmpleador),
      expression: "TxtEmailIngresoEmpleador"
    }],
    ref: "refEmail",
    staticClass: "input-text",
    attrs: {
      "type": "email",
      "placeholder": "Correo electrónico"
    },
    domProps: {
      "value": (_vm.TxtEmailIngresoEmpleador)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.onEnterEmailClick($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.TxtEmailIngresoEmpleador = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TxtClaveIngresoEmpleador),
      expression: "TxtClaveIngresoEmpleador"
    }],
    ref: "refPassword",
    staticClass: "input-text",
    attrs: {
      "type": "password",
      "placeholder": "Contraseña"
    },
    domProps: {
      "value": (_vm.TxtClaveIngresoEmpleador)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.onEnterPassClick($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.TxtClaveIngresoEmpleador = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "checkbox clearfix"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.olvidoContrasena()
      }
    }
  }, [_vm._v("¿ Olvidó su contraseña ?")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12 margin_bottom"
  }, [_c('button', {
    staticClass: "btn btn-block btn-lg btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.Login
    }
  }, [_c('i', {
    staticClass: "fa fa-user margin-left-25",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" ENTRAR")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 margin_bottom"
  }, [_c('button', {
    staticClass: "btn btn-block btn-lg btn-secondary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.CrearCuentaEmpleador
    }
  }, [_c('i', {
    staticClass: "fa fa-smile-o margin-left-25",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" SOY NUEVO")])])])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('div', [_c('square')], 1) : _c('div', {
    class: _vm.ajusteColumna
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "card-flat"
  }, [_c('div', {
    staticClass: "container-card"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loginUser),
      expression: "!loginUser"
    }],
    staticClass: "alert alert-info"
  }, [_vm._m(3)])]), _vm._v(" "), _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginUser),
      expression: "loginUser"
    }],
    staticClass: "titulo6"
  }, [_c('span', [_vm._v("Descripción oferta")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginUser),
      expression: "loginUser"
    }]
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtTitulo),
      expression: "txtTitulo"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.submitted && _vm.$v.txtTitulo.$error
    },
    attrs: {
      "type": "text",
      "id": "txtTitulo",
      "readonly": !_vm.loginUser
    },
    domProps: {
      "value": (_vm.txtTitulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtTitulo = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.txtTitulo.required) ? _c('div', [_c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v(" Campo requerido")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group  selFrom-search"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cmbClasificacion),
      expression: "cmbClasificacion"
    }],
    staticClass: "dropdown-product selectpicker",
    attrs: {
      "data-live-search": "true",
      "disabled": !_vm.loginUser
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cmbClasificacion = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": "-1"
    }
  }, [_vm._v(" SELECCIONAR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(" Arte/Diseño")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Economía")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Informática")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Telecomunicaciones")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Educación y Psicopedagogía")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Contabilidad")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("Estética")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Hotelería Turismo y Gastronomía")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("Logística")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Marketing y Publicidad")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("Salud")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("Operarios")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "13"
    }
  }, [_vm._v("Profesionales y Técnicos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("Prácticas profesionales")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("Recepción / Secretaria")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "16"
    }
  }, [_vm._v("Recursos Humanos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "17"
    }
  }, [_vm._v("Seguridad")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18"
    }
  }, [_vm._v("Servicios Domésticos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "19"
    }
  }, [_vm._v("Trabajos Universitarios")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("Ventas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "21"
    }
  }, [_vm._v("Comercial")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "22"
    }
  }, [_vm._v("Otros")])]), _vm._v(" "), (_vm.submitted && !_vm.$v.cmbClasificacion.between) ? _c('div', [_c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v(" Debe de seleccionar una opción")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtDescripcion),
      expression: "txtDescripcion"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "textarea",
      "rows": "8",
      "cols": "50",
      "placeholder": "Descripción de la Oferta, Beneficios ",
      "readonly": !_vm.loginUser
    },
    domProps: {
      "value": (_vm.txtDescripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtDescripcion = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.txtDescripcion.required) ? _c('div', [_c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v(" Campo requerido")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cmbDuracionContrato),
      expression: "cmbDuracionContrato"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "disabled": !_vm.loginUser
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cmbDuracionContrato = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": "-1"
    }
  }, [_vm._v(" NO ES RELEVANTE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Plazo fijo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Indefinido")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Por obra o faena")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Part time")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Práctica profesional")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Otro")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cmbDuracionContrato),
      expression: "cmbDuracionContrato"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "disabled": !_vm.loginUser
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cmbDuracionContrato = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": "-1"
    }
  }, [_vm._v(" NO ES RELEVANTE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Tiempo completo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Part time ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Tiempo completo + Part time")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cmbTipoContrato),
      expression: "cmbTipoContrato"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "disabled": !_vm.loginUser
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cmbTipoContrato = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": "-1"
    }
  }, [_vm._v(" NO ES RELEVANTE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Presencial")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Trabajo remoto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Presencial + Trabajo remoto")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "NO ES RELEVANTE",
      "readonly": !_vm.loginUser
    }
  })])])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtDireccion),
      expression: "txtDireccion"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": !_vm.loginUser
    },
    domProps: {
      "value": (_vm.txtDireccion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtDireccion = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.txtDireccion.required) ? _c('div', [_c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v(" Campo requerido")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group selFrom-search"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cmbUbicacion),
      expression: "cmbUbicacion"
    }],
    staticClass: "dropdown-product selectpicker",
    attrs: {
      "data-live-search": "true",
      "disabled": !_vm.loginUser
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cmbUbicacion = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("SELECCIONAR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("I Tarapaca")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("II Antofagasta")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("III Atacama")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("IV coquimbo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("V Valparaíso")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("VI O'Higgins")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("VII Maule")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("VIII Bio Bio")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("IX La Auraucanía")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("X Los Lagos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("XI Aysén")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("XII Magallanes y Antárt.")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "13"
    }
  }, [_vm._v("XIII Metropolitana Santiago")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("XIV Los Ríos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("XV Arica y Parinacota ")])]), _vm._v(" "), (_vm.submitted && !_vm.$v.cmbUbicacion.between) ? _c('div', [_c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v(" Debe de seleccionar una opción")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": !_vm.loginUser
    }
  })])])])]), _vm._v(" "), _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginUser),
      expression: "loginUser"
    }],
    staticClass: "titulo6"
  }, [_c('span', [_vm._v("Requisitos")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginUser),
      expression: "loginUser"
    }]
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cmbEducacion),
      expression: "cmbEducacion"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "disabled": !_vm.loginUser
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cmbEducacion = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": "-1"
    }
  }, [_vm._v(" NO ES RELEVANTE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Educación media")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Educación técnica")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Educación universitaria")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Educación técnica o universitaria")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Magister")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Doctorado")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cmbExperiencia),
      expression: "cmbExperiencia"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "disabled": !_vm.loginUser
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cmbExperiencia = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": "-1"
    }
  }, [_vm._v(" SIN AÑOS DE EXPERIENCIA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Menos de 1 año")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2 años")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3 años")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Más de 4 años")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cmbViaje),
      expression: "cmbViaje"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "disabled": !_vm.loginUser
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cmbViaje = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Si")])])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginUser),
      expression: "loginUser"
    }],
    staticClass: "col-md-12"
  }, [_c('label', {
    class: _vm.ajusteColumnaBoton
  }, [_vm._v("(*) Ingreso obligatorio")]), _vm._v(" "), _c('button', {
    staticClass: "btn-sm btn-primary col-md-3",
    on: {
      "click": function($event) {
        _vm.publicar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-briefcase",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Publicar trabajo")]), _vm._v(" "), _vm._m(18)]), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalPlanes",
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('planes-disponibles')], 1), _vm._v(" "), _vm._m(20)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-home",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Inicio")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active",
    attrs: {
      "aria-current": "page"
    }
  }, [_vm._v("Publicar oferta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 row"
  }, [_c('label', {
    staticClass: "titulo4"
  }, [_c('i', {
    staticClass: "fa fa-tag",
    staticStyle: {
      "color": "#FF4B3A"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Publicar oferta de trabajo\r\n            ")]), _vm._v(" "), _c('hr', {
    staticClass: "Hr-Titulo"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('span', [_vm._v("Ingreso empleador")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('img', {
    staticStyle: {
      "width": "35px"
    },
    attrs: {
      "src": require("../../../static/img/login.png")
    }
  }), _vm._v(" Para publicar una oferta de trabajo debe de iniciar sesión en \"Ingreso empleador\" ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "label-destacado2"
  }, [_vm._v("Puesto / Título(*)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "label-destacado2"
  }, [_vm._v("Clasificación(*)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "label-destacado2"
  }, [_vm._v("Descripción(*)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "label-destacado2"
  }, [_vm._v("Duración contrato")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "label-destacado2"
  }, [_vm._v("Tipo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "label-destacado2"
  }, [_vm._v("Jornada")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "label-destacado2"
  }, [_vm._v("Sueldo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "titulo6 col-md-12 row"
  }, [_c('span', [_vm._v("Ubicación")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "label-destacado2"
  }, [_vm._v("Dirección(*)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "label-destacado2"
  }, [_vm._v("Ubicación(*)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "label-destacado2"
  }, [_vm._v("Comuna(*)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "label-destacado2"
  }, [_vm._v("Educación mínima")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "label-destacado2"
  }, [_vm._v("Años de experiencia")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "label-destacado2"
  }, [_vm._v("Disponibilidad viaje")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn-sm btn-info col-md-3 ",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-eye",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Ver antes de publicar")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticClass: "modal-title"
  }, [_vm._v("Planes Disponibles")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cerrar")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b14e7bda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/IngresoOfertaView.vue
// module id = 664
// module chunks = 1